export const GET_NEARING_EXPIRY_SERVICES = gql`
    query retrieveNearingExpiryServices {
        retrieveNearingExpiryServices {
            id
            serviceNumber
            contractExpiry
            tradingName
            partnerName
            merchantAccountNumber
            daysToExpiry
            expiryText
        }
    }
`;
